module.exports = "/cyber/_next/static/images/bestGames-9144fb890f57c50ef3e3421399c15c92.jpg";